const Urls = {
  base: '/',
  front: {
    login: '/login',
    password: {
      reset: '/reset-password',
      forgot: '/forgot-password',
    },
    logout: '/logout',
  },
  apikey: '/api-key',
  trip: '/trip',
  authorization: '/authorisation',
  dashboard: '/dashboard',
  preferences: '/preferences',
  agency: '/agency',
  invoice: '/invoice',
  user: '/user',
  userProfile: '/user-profile',
  legal_mention: '/mention-legal',
  cgu: '/cgu',
  cookie_policy: '/cookie-policy',
  profile: {
    base: '/profile',
    object: '/profile/:key',
  },
  assignation: '/assignation',
  register: '/register',
  group: '/groupes',
};

export default Urls;
